// @flow
import specialPacks from './products/specialPacks/menuSpecialPacks'
import beer from './products/beer/menuBeer'
import glassware from './products/glassware'

export default {
  specialPacks,
  beer,
  glassware
}
